module.exports = {
  platform: 'voice',
  name: 'api',
  node: 'api',
  bg: '#FFFFFF',
  note: '',
  property: {
    methods: 'GET',
    url: '',
    headers: [{ key: 'content-type', value: 'application/json' }],
    body: '',
    setting: {
      timeout: '30.0',
      await: true
    }
  }
}
